import script from "./ArgonSearcherSimplified.vue?vue&type=script&setup=true&lang=js"
export * from "./ArgonSearcherSimplified.vue?vue&type=script&setup=true&lang=js"

import "./ArgonSearcherSimplified.vue?vue&type=style&index=0&id=909c7b7e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-909c7b7e"]])

export default __exports__